// libs
import React, { memo } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// defs
import type { Analytics, BillWidgetLineItem } from "@payment-client/interfaces/Checkout";

// styles
import { Row, HCell, Label } from "./styled";

// utils
import { isEmpty } from "@swiggy-private/js-utils";

// hooks
import { useEffectOnce } from "@swiggy-private/core-ui";

// context
interface IProps {
    lineItem: BillWidgetLineItem;
    captureImpression: (payload: Analytics) => void;
}

const BillLineItem = ({ lineItem, captureImpression }: IProps) => {
    useEffectOnce(() => {
        captureImpression(lineItem.analytics);
    });

    const getTextStyles = (dlsColor?: string) => {
        if (!isEmpty(dlsColor)) {
            return { color: dlsColor };
        }

        return {};
    };

    return (
        <Row>
            {lineItem.items.map((cell) => {
                const { details, labelInfo } = cell.displayContent || {};
                const textContent = details?.[0]?.text?.content || "";
                const labelText = labelInfo?.content;

                return (
                    <HCell key={textContent}>
                        <Text
                            variant="V2.body2.neutral.regular"
                            color="text_Med_Emphasis"
                            style={getTextStyles(details?.[0]?.text?.dlsColor)}
                        >
                            {textContent}
                        </Text>
                        {labelText && (
                            <Label variant="V2.caption.neutral.bold" color="positive">
                                {labelText}
                            </Label>
                        )}
                    </HCell>
                );
            })}
        </Row>
    );
};

export default memo(BillLineItem);
